import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheDigitalTradeBridge from "./sections/TheDigitalTradeBridge";
import TradeCorridorMap from "./sections/TradeCorridorMap";
import CoreTradePillars from "./sections/CoreTradePillars";
import EconomicSynergyInsights from "./sections/EconomicSynergyInsights";
import BridgeTheGap from "./sections/BridgeTheGap";
import EuropeanTradeCorridorInsights from "./sections/EuropeanTradeCorridorInsights";
import SiteFooter from "@/reusable_sections/Footer";
import AutoRotatingImageSlider from "./sections/AutoRotatingImageSlider";
export default function HomePage() {
  return <div>
      <Header />
      <TheDigitalTradeBridge />
      <TradeCorridorMap />
      <CoreTradePillars />
      <AutoRotatingImageSlider />
      <EconomicSynergyInsights />
      <EuropeanTradeCorridorInsights />
      <BridgeTheGap />
      <SiteFooter />
    </div>;
}